import teacherRequest from './teacherRequest'

export const EXPORT_QUOTA_EXCEEDED_CODE = 1002

export class ExportQuotaError extends Error {
  constructor(message, code = EXPORT_QUOTA_EXCEEDED_CODE) {
    super(message || '讲义导出次数已用完')
    this.name = 'ExportQuotaError'
    this.code = code
  }
}

export function fetchExportQuota() {
  return teacherRequest.get('/export-billing/quota')
}

export function fetchExportProducts() {
  return teacherRequest.get('/export-billing/products')
}

export function createExportPayOrder(productId) {
  return teacherRequest.post('/export-billing/create-order', { productId })
}

export function fetchExportOrderStatus(orderNo) {
  return teacherRequest.get(`/export-billing/order/${encodeURIComponent(orderNo)}`)
}

export function mockConfirmExportPay(orderNo) {
  return teacherRequest.post(`/export-billing/mock-pay/${encodeURIComponent(orderNo)}`)
}

export function buildWeChatQrImageUrl(codeUrl) {
  return buildPayQrImageUrl(codeUrl)
}

export function buildPayQrImageUrl(codeUrl) {
  if (!codeUrl || String(codeUrl).startsWith('mock://')) return ''
  return `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(codeUrl)}`
}
